/* Shared pieces of the pages for Google (mock Seo_3): the list of cities with cars and
   drivers, written by the build (scripts/prerenderRoutes.mjs -> /seo-index.json), and
   the questions and links under each page. */

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/* The fare-chart, airport and drop pages as links (mock Seo_12), by their first folder. */
export const HUB_LINK_WORDS = {
  en: { "taxi-fare": "Taxi fare chart", "airport-taxi": "Airport taxi", "drop-taxi": "One way drop taxi" },
  te: { "taxi-fare": "ట్యాక్సీ ఛార్జీల పట్టిక", "airport-taxi": "ఎయిర్‌పోర్ట్ ట్యాక్సీ", "drop-taxi": "వన్ వే డ్రాప్ ట్యాక్సీ" },
};

export const SEO_CARD = "bg-white rounded-2xl border border-[#E5E7EB] shadow-[0_2px_10px_rgba(15,23,42,0.04)]";

let cached = null;
let pending = null;

/** { cabs: [{ city, n, types: [slug] }], drivers: [{ city, n }] } - or null while loading. */
export function useSeoIndex() {
  const [index, setIndex] = useState(cached);
  useEffect(() => {
    if (cached) return undefined;
    let live = true;
    pending = pending || fetch("/seo-index.json", { cache: "no-cache" }).then((r) => (r.ok ? r.json() : null)).catch(() => null);
    pending.then((j) => { cached = j || { cabs: [], drivers: [] }; if (live) setIndex(cached); });
    return () => { live = false; };
  }, []);
  return index;
}

/** Questions [[q, a]] and links [[to, words]] under a page. */
export function SeoFooter({ faq = [], links = [], title = "More on Sramika" }) {
  return (
    <section className={`${SEO_CARD} p-3 mt-3 mb-2`}>
      {links.length > 0 && (
        <>
          <h2 className="text-[12.5px] font-extrabold text-[#0F172A]">{title}</h2>
          <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1">
            {links.map(([to, words]) => <Link key={to + words} to={to} className="text-[12px] font-bold text-[#3F5E00]">{words}</Link>)}
          </div>
        </>
      )}
      {faq.map(([q, a]) => (
        <div key={q} className="mt-2.5">
          <h2 className="text-[12.5px] font-extrabold text-[#0F172A]">{q}</h2>
          <p className="text-[11.5px] text-[#475569] leading-snug mt-0.5">{a}</p>
        </div>
      ))}
    </section>
  );
}
